import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import PaginateList from "../../../utils/PaginateList";
import * as LocationServices from "../../../../services/LocationService";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import {
  ButtonAction,
  ButtonClose,
  Icon,
  Option,
  ListOptions,
} from "./locationList.styled";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import {} from "../../../security/permissions/rolesPermission";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

const LocationListContainer = ({ filters, sortBy }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const context = useContext(AbilityContext);

  const columns = [
    {
      header: t("forms.location.table.heads.name"),
      accessorKey: "name",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.location.table.heads.vivero"),
      accessorKey: "vivero.name",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.location.table.heads.active"),
      accessorKey: "active",
      cell: (info) => {
        if (info.getValue()) {
          return t("yes");
        }

        return t("no");
      },
    },
    {
      Header: " ",
      accessorKey: " ",
      cell: (info) => renderAction(info.row.original),
    },
  ];

  const goToEdit = (uuid) => {
    navigate(`/user/location/form/update/${uuid}`);
  };

  const renderAction = (data) => {
    return (
      <div className="text-center">
        <ButtonAction onClick={() => goToEdit(data.uuid)} type="button">
          <i className="fa-regular fa-pen-to-square"></i>
        </ButtonAction>
        <ButtonAction
          onClick={() => showDialogOnDelete(data.uuid)}
          type="button"
        >
          <Icon className="fa-solid fa-trash-can"></Icon>
        </ButtonAction>
      </div>
    );
  };

  const showDialogOnDelete = (uuid) => {
    const okAction = async () => {
      LocationServices.deleteLocation(uuid).then((result) => {
        if (result && result.deleted === true) {
          setForceRefresh(true);
        }
      });
    };

    const cancelAction = () => {};

    ShowAlertDialog(
      t("forms.location.dialog.remove.title"),
      t("forms.location.dialog.remove.text"),
      "warning",
      true,
      t("forms.location.dialog.remove.buttonOk"),
      false,
      okAction,
      t("forms.location.dialog.remove.buttonNo"),
      cancelAction
    );
  };

  const listData = async (filter) => {
    // if (sortBy) {
    //   filter.sort = sortBy;
    // } else {
    //   filter.sort = "-date";
    // }
    const result = await LocationServices.listFilter(filter);
    return result;
  };

  const hideColumn = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    // hideColumn.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    // hideColumn.itemCode = false;
  }

  return (
    <PaginateList
      refresh={forceRefresh}
      filters={filters}
      columns={columns}
      toList={listData}
      hideColum={hideColumn}
      resize={resize}
      resetRefresh={() => setForceRefresh(false)}
    ></PaginateList>
  );
};

LocationListContainer.propTypes = {
  filters: PropTypes.object,
};

export default LocationListContainer;
